const env = process.env.NODE_ENV;

export let API_URL;
if (env === 'development') {
  API_URL = 'http://localhost:8080/api';
} else {
  API_URL = 'https://falcon-softwood.ltfirewood.com/api';
}

export const FACTORY_NAME = 'Softwood';
export const FACTORY_URL = 'https://falcon-softwood.ltfirewood.com';
export const PELLETS_URL = 'https://falcon-pellet.ltfirewood.com';



// WEBPACK FOOTER //
// ./src/config/config.js